@if (isMenu) {
  <button mat-menu-item>
    <div class="item-menu-center">
      <span class="material-symbols-outlined"> mark_email_unread </span>
      <span> {{ 'setUnread' | translate }}</span>
    </div>
  </button>
} @else {
  <button mat-icon-button matTooltip="{{ 'setUnread' | translate }}">
    <span class="material-symbols-outlined"> mark_email_unread </span>
  </button>
}
